import { Auth0Client } from "@auth0/auth0-spa-js";
import PaymentMethodClient from "./PaymentMethodClient";
import { auth0Config } from "../../config";
import {
  CreatePaymentMethodDto,
  PaymentMethodResponseDto,
  CaptureSession,
} from "../../types/payment-method";

class PaymentMethodApi {
  private auth0Client: Auth0Client;

  private paymentMethodClient: PaymentMethodClient;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
    this.paymentMethodClient = new PaymentMethodClient(this.auth0Client);
  }

  async getSetupIntent(orgId: string): Promise<CaptureSession> {
    return this.paymentMethodClient.getSetupIntent(orgId);
  }

  async updatePaymentMethod(
    orgId: string,
    payload: Record<string, unknown>,
  ): Promise<PaymentMethodResponseDto> {
    return this.paymentMethodClient.updatePaymentMethod(orgId, payload);
  }

  async getPaymentMethod(orgId: string): Promise<PaymentMethodResponseDto[]> {
    return this.paymentMethodClient.getPaymentMethod(orgId);
  }

  async deletePaymentMethod(orgId: string): Promise<void> {
    return this.paymentMethodClient.deletePaymentMethod(orgId);
  }

  async deletePaymentMethodById(id: string): Promise<void> {
    return this.paymentMethodClient.deletePaymentMethodById(id);
  }

  async setDefault(id: string): Promise<PaymentMethodResponseDto> {
    return this.paymentMethodClient.setDefault(id);
  }

  async getDimepayCardStatus(
    token: string,
  ): Promise<{ verified: boolean; status: string; token?: string }> {
    return this.paymentMethodClient.getDimepayCardStatus(token);
  }

  async createPaymentMethod(
    payload: CreatePaymentMethodDto,
  ): Promise<PaymentMethodResponseDto> {
    return this.paymentMethodClient.createPaymentMethod(payload);
  }
}

export default PaymentMethodApi;
